import { render } from "./Nav.vue?vue&type=template&id=81d0d65a&scoped=true"
const script = {}

import "./Nav.vue?vue&type=style&index=0&id=81d0d65a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Fabiano\\OneDrive\\Área de Trabalho\\Project\\ijrmudancasecarretos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81d0d65a"]])

export default __exports__